import { useState } from 'react';
import styled from 'styled-components';
import { Colors, fonts } from '../style/GlobalStyles';

const Outer = styled.section`
  padding: 0 1.5rem;

  @media (max-width: 768px) {
    padding: 0 0.75rem;
  }
`;

const Card = styled.div`
  background: ${Colors.oxblood};
  color: ${Colors.paper};
  border-radius: 40px;
  max-width: 1320px;
  margin: 0 auto;
  padding: 5rem 4rem;

  @media (max-width: 768px) {
    padding: 3rem 1.5rem;
    border-radius: 28px;
  }
`;

const Label = styled.span`
  display: inline-block;
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 0.95rem;
  color: ${Colors.paper};
  padding: 0.55rem 1.4rem;
  border: 1.5px solid rgba(242, 239, 230, 0.5);
  border-radius: 999px;
  margin-bottom: 2.5rem;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 2rem;
  margin-bottom: 3.5rem;

  @media (max-width: 880px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
  }
`;

const Title = styled.h2`
  font-family: ${fonts.display};
  font-weight: 400;
  text-transform: uppercase;
  line-height: 0.95;
  color: ${Colors.paper};
  font-size: clamp(2.4rem, 6vw, 5rem);
  margin: 0;
`;

const Intro = styled.p`
  font-family: ${fonts.body};
  color: rgba(242, 239, 230, 0.78);
  font-size: 1rem;
  line-height: 1.65;
  max-width: 340px;
  margin: 0;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

const FieldRow = styled.div`
  display: flex;
  gap: 2.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const Field = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(242, 239, 230, 0.4);
  color: ${Colors.paper};
  font-family: ${fonts.body};
  font-size: 1rem;
  padding: 0.6rem 0;
  outline: none;

  &::placeholder {
    color: rgba(242, 239, 230, 0.55);
  }
  &:focus {
    border-bottom-color: ${Colors.lime};
  }
`;

const Message = styled.input`
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(242, 239, 230, 0.4);
  color: ${Colors.paper};
  font-family: ${fonts.body};
  font-size: 1rem;
  padding: 0.6rem 0;
  outline: none;
  flex: 1;

  &::placeholder {
    color: rgba(242, 239, 230, 0.55);
  }
  &:focus {
    border-bottom-color: ${Colors.lime};
  }
`;

const Submit = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const SubmitBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 1.05rem;
  color: ${Colors.paper};
  text-decoration: underline;
  text-underline-offset: 6px;
  transition: color 0.2s;

  &:hover {
    color: ${Colors.lime};
  }
`;

const Contact = () => {
  const [form, setForm] = useState({ name: '', company: '', email: '', message: '' });

  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const subject = `Let's work together — ${form.name || 'New message'}`;
    const body =
      `Name: ${form.name}\nCompany: ${form.company}\nEmail: ${form.email}\n\n${form.message}`;
    window.location.href =
      `mailto:santiagoestrada.dev@gmail.com?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <Outer>
      <Card>
        <Label className="gsap-fade-up">Contact me</Label>
        <Top>
          <Title className="gsap-fade-up">
            Let's work
            <br />
            together
          </Title>
          <Intro className="gsap-fade-up">
            Have a project or role in mind? Reach out and let's talk about how I
            can help you ship it.
          </Intro>
        </Top>
        <Form className="gsap-fade-up" onSubmit={submit}>
          <FieldRow>
            <Field name="name" placeholder="Name" value={form.name} onChange={change} required />
            <Field
              name="company"
              placeholder="Company name"
              value={form.company}
              onChange={change}
            />
            <Field
              name="email"
              type="email"
              placeholder="example@gmail.com"
              value={form.email}
              onChange={change}
              required
            />
          </FieldRow>
          <FieldRow>
            <Message
              name="message"
              placeholder="Type message"
              value={form.message}
              onChange={change}
            />
            <Submit>
              <SubmitBtn type="submit">Send a message →</SubmitBtn>
            </Submit>
          </FieldRow>
        </Form>
      </Card>
    </Outer>
  );
};

export default Contact;
